import React from 'react';

const SectionHeading = ({ 
  eyebrow, 
  title, 
  description, 
  centered = false,
  id = undefined
}) => {
  return (
    <div className={`max-w-3xl ${centered ? 'mx-auto text-center' : ''} mb-16`}>
      {eyebrow && (
        <div className={`mb-4 ${centered ? 'inline-flex items-center justify-center' : ''}`}>
          {centered ? (
            <>
              <div className="w-12 h-1 bg-blue-800 rounded-full mr-4"></div>
              <span className="text-blue-800 font-medium uppercase text-sm tracking-wider">{eyebrow}</span>
              <div className="w-12 h-1 bg-blue-800 rounded-full ml-4"></div>
            </>
          ) : (
            <>
              <div className="inline-flex items-center mb-2">
                <div className="h-px w-10 bg-blue-800"></div>
                <span className="text-blue-800 font-medium uppercase text-xs sm:text-sm tracking-wider mx-3">{eyebrow}</span>
              </div>
            </>
          )}
        </div>
      )}
      
      <h2 
        id={id} 
        className="text-4xl lg:text-5xl font-bold mb-6 text-gray-900 leading-tight"
      >
        {title}
      </h2>
      
      {description && (
        <p className={`text-gray-600 text-lg ${centered ? 'mx-auto' : ''}`}>
          {description}
        </p>
      )}
    </div>
  );
};

export default SectionHeading;